import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { business } from '../data/business';
import { ui } from '../data/translations';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="home" className="relative isolate w-full overflow-hidden bg-navy-deep" data-id="element-151" data-mp="9ipbpaa4vbzl">
      <img src={business.heroImage} alt={t(ui.hero.imageAlt)} className="absolute inset-0 -z-20 h-full w-full object-cover object-center" data-id="element-152" data-mp="4njrcfwdq5dm" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-navy-deep/75 lg:bg-navy-deep/65" data-id="element-153" data-mp="xbfmhg6avp8a" />

      <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-5 py-20 lg:min-h-[640px] lg:px-8" data-id="element-154" data-mp="sa9nj0m1r5qb">
        <div className="max-w-2xl" data-id="element-155" data-mp="nbygexn4z9bs">
          <h1 className="font-display text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-156" data-mp="3d1ihv20l0yjq">
            {t(ui.hero.titleBefore)}
            <span className="text-gold" data-id="element-157" data-mp="380vy3velgpc3">{t(ui.hero.titleHighlight)}</span>
            {t(ui.hero.titleAfter)}
          </h1>
          <p className="mt-5 max-w-xl text-lg text-white/85" data-id="element-158" data-mp="3j6fvvj9ob1ao">{t(ui.hero.subtitle)}</p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-159" data-mp="3o6u6n92nspce">
            <a href="#contact" className="inline-flex h-14 items-center justify-center whitespace-nowrap rounded-md bg-gold px-7 font-display text-base font-semibold text-navy-deep transition-colors duration-150 hover:bg-gold-dark" data-id="element-160" data-mp="399b9pjftv5tv">
              {t(ui.cta.estimate)}
            </a>
            <a href={business.phoneHref} className="inline-flex h-14 items-center justify-center gap-2 whitespace-nowrap rounded-md border-2 border-white/70 px-7 font-display text-base font-semibold text-white transition-colors duration-150 hover:border-gold hover:text-gold" data-id="element-161" data-mp="35aasu6gwud9i">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-162" data-mp="2hl9r122l20d7" />
              {t(ui.cta.callNow)}
            </a>
          </div>

          <p className="mt-8 text-sm text-white/70" data-id="element-163" data-mp="s1rtgrkfwcvv">
            {t(ui.hero.serving)} {t(business.serviceArea)} · {t(ui.hero.freeNote)}
          </p>
        </div>
      </div>
    </section>;
}